import { useContext } from 'react';
import { SpiderXContext } from '../context/SpiderXContext';

const useSpiderX = () => {
  const spiderx = useContext(SpiderXContext);

  return spiderx;
};
export default useSpiderX;
